import axios from 'axios';

export const callGoogleAuthAPI = async (folderId = '1C_yZNgjPPbBPURKmPJskqNSpm62vW9Ve') => {
    try {
        const response = await axios.get('https://drive-connector.eleven-ws.com/server/api/files',{
            params: {
                folderId: folderId, // クエリパラメータにフォルダーIDを設定
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error calling Google Auth API:', error);
        throw error;
    }
};
